module.exports = __webpack_public_path__ + "static/media/creed-aventus-big.9578bc6e.png";